import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';

export type PlantPageView = 'basic' | 'advanced';

interface PlantsStore {
  pageView: PlantPageView;
  setPageView: (pageView: PlantPageView) => void;
  selectedPlant: TPlant | undefined;
  setSelectedPlant: (plants: TPlant | undefined) => void;
}

export const usePlantsStore = create<PlantsStore>()(
  devtools((set) => ({
    pageView: 'advanced',
    setPageView: (pageView) =>
      set({
        pageView,
      }),
    selectedPlant: undefined,
    setSelectedPlant: (plant) =>
      set({
        selectedPlant: plant,
      }),
  }))
);
